<script setup>
import Checkbox from './Checkbox.vue'

defineProps({
  type: {
    type: String,
    default: 'store',
  },
  users: {
    type: Array,
    required: true,
  },
  permissionsList: {
    type: Array,
    required: true,
  },
  id: {
    type: String,
    required: true,
  },
  updateUserPermission: {
    type: Function,
    required: true,
  },
  onSave: {
    type: Function,
    required: true,
  },
  onDelete: {
    type: Function,
    required: true,
  },
})
</script>

<template>
  <div>
    <table class="user-permissions-table">
      <thead>
        <tr>
          <th>Name</th>
          <th v-for="header in permissionsList" :key="header">Hidden {{ header.label }}</th>
          <th width="190"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(user, index) in users" :key="user.email">
          <td>{{ user.email }}</td>
          <td v-for="permission in permissionsList" :key="permission.name">
            <Checkbox
              :checked="user.hiddenFields[permission.name]"
              :readonly="permission.disabled"
              :update="
                (checked) =>
                  updateUserPermission({
                    path:
                      type === 'store'
                        ? `storeUsers[${index}][hiddenFields]${[permission.name]}`
                        : `clientUsers[${index}][hiddenFields]${[permission.name]}`,
                    value: checked,
                  })
              "
            />
          </td>
          <td>
            <button
              type="button"
              class="success permissions-btn"
              @click.prevent="
                () =>
                  onSave({
                    id,
                    userId: user.id,
                    permissions: user.hiddenFields,
                  })
              "
            >
              Save
            </button>
            <button type="button" class="error permissions-btn" @click.prevent="() => onDelete({ id, userId: user.id })">Delete</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
